import React, { useState } from "react";

import classNames from "classnames";
import PropTypes from "prop-types";

import useMatchMedia from "~hooks/use_match_media/use_match_media";

import { LINK } from "../../../../../prop_types";
import RscHbNavExpandingMenuCategory from "../rsc_hb_nav_expanding_menu_category/rsc_hb_nav_expanding_menu_category";
import RscHbNavLink from "../rsc_hb_nav_link/rsc_hb_nav_link";
import {
  expandingMenuWrapperStyle,
  isVisibleStyle,
  itemWrapperStyle,
} from "./rsc_hb_nav_expanding_menu.module.scss";

function RscHbNavExpandingMenu({ items, level1ActiveItem, level2ActiveItem }) {
  const isMobileWindow = useMatchMedia({ max: "M" });

  const [level1ActiveItemIndex, setLevel1ActiveItemIndex] = useState(
    items?.findIndex((item) => {
      return item.slug === level1ActiveItem;
    })
  );

  const expandingMenuWrapperClassnames = classNames(expandingMenuWrapperStyle, {
    [isVisibleStyle]: isMobileWindow,
  });

  return (
    <div className={expandingMenuWrapperClassnames}>
      {items?.length &&
        items.map((item, index) => {
          const isActive = index === level1ActiveItemIndex;

          if (item?.items?.length > 0) {
            return (
              <div key={item.title} className={itemWrapperStyle}>
                <RscHbNavExpandingMenuCategory
                  index={index}
                  {...item}
                  activeItem={level2ActiveItem}
                  onClick={setLevel1ActiveItemIndex}
                  isActive={isActive}
                />
              </div>
            );
          }
          return (
            <div key={item.title} className={itemWrapperStyle}>
              <RscHbNavLink
                isFontRegular
                index={index}
                {...item}
                onClick={setLevel1ActiveItemIndex}
                isActive={isActive}
              />
            </div>
          );
        })}
    </div>
  );
}

RscHbNavExpandingMenu.defaultProps = {
  items: [],
  level1ActiveItem: "",
  level2ActiveItem: "",
  shouldShowMenuOnMobile: false,
};

RscHbNavExpandingMenu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({ title: PropTypes.string, link: LINK })
  ),
  level1ActiveItem: PropTypes.string,
  level2ActiveItem: PropTypes.string,
  shouldShowMenuOnMobile: PropTypes.bool,
};

export default RscHbNavExpandingMenu;
